import React from 'react'
import { themeColors } from 'training-lane-booking-shared/utilities/constants'

const CartIcon = ({ hasItems = false, size = 20, thickness = 1.7 }) => {
    const baseColor = hasItems ? themeColors.brandRed : themeColors.brandBlue

    const computedHeight = size * 0.85

    const extraPolygonThickness = thickness > 1.7 ? thickness - 1.7 : 0

    const maskId = 'cart-gap-mask'

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={computedHeight}
            viewBox="1.0 3.5 19 20.5"
            fill="none"
            style={{ display: 'block', marginBottom: -5 }}>
            <defs>
                <mask id={maskId}>
                    <rect x="0" y="0" width="24" height="24" fill="white" />
                    <rect x="0" y="17" width="24" height="4" fill="black" />
                </mask>
            </defs>

            <g
                fill={baseColor}
                mask={`url(#${maskId})`}
                stroke={baseColor}
                strokeWidth={extraPolygonThickness}
                strokeLinejoin="miter" // Keeps the polygon corners sharp
            >
                {/* Left Continuous Pillar (Wall + Wheel) */}
                <polygon points="1.15,8 2.85,8 5.73,24 4.03,24" />

                {/* Right Continuous Pillar (Wall + Wheel) */}
                <polygon points="18.15,3.5 19.85,3.5 15.30,24 13.60,24" />
            </g>

            {/* Top Horizontal Line */}
            <line
                x1="6"
                y1="9"
                x2="14"
                y2="9"
                stroke={baseColor}
                strokeWidth={thickness}
            />

            {/* Bottom Horizontal Line */}
            <line
                x1="8"
                y1="16"
                x2="12"
                y2="16"
                stroke={baseColor}
                strokeWidth={thickness}
            />
        </svg>
    )
}

export default CartIcon
